<template>
  <v-card
    width="135px"
    class="mr-2 mb-1 px-1"
    :style="{ 'background-color': route.routeColor }"
  >
    <v-card-title class="py-1 px-0">
      <v-layout align-center>
        <span v-if="route.routeId">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="ml-1"
                v-on="on"
              >local_shipping</v-icon>
            </template>
            <span>Поставка в маршруте</span>
          </v-tooltip>
        </span>
        <RoutesShippingsDialog
          :route="route"
          class="ml-1"
        />
        <v-spacer />
        <v-progress-circular
          v-if="loading && compactMode"
          indeterminate
          :size="20"
          color="primary"
          width="2"
          class="my-1"
        />
        <MenuRouteCard
          v-if="compactMode && !loading"
          :route-id="route.routeId"
          :in-car="isInCar"
          @create="createRoute"
          @delete="deleteRoute"
        />
      </v-layout>
    </v-card-title>
    <v-card-text
      v-if="!compactMode"
      class="py-1 px-0"
    >
      <v-layout>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-layout
              align-center
              v-on="on"
            >
              <v-icon class="mr-1">
                today
              </v-icon>
              <span class="body-2 font-weight-bold">{{
                routeLoadingDate | date
              }}</span>
            </v-layout>
          </template>
          <span>{{
            routeLoadingDate ? "Дата погрузки" : "Дата погрузки не установлена"
          }}</span>
        </v-tooltip>
      </v-layout>
      <v-layout>
        <span class="body-2 mx-1">W:</span>
        <span class="body-2 font-weight-bold">
          {{
            route.summaryInfo ? route.summaryInfo.weight.toFixed(2) : 0
          }}</span>
      </v-layout>
      <v-layout>
        <span class="body-2 mx-1">V:</span>
        <span class="body-2 font-weight-bold">{{
          route.summaryInfo ? route.summaryInfo.volume.toFixed(2) : 0
        }}</span>
        <v-spacer />
        <v-progress-circular
          v-if="loading"
          indeterminate
          :size="20"
          color="primary"
          width="2"
          class="my-1"
        />
        <MenuRouteCard
          v-if="!loading"
          :route-id="route.routeId"
          :in-car="isInCar"
          @create="createRoute"
          @delete="deleteRoute"
        />
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import RoutesShippingsDialog from "./RoutesShippingsDialog.vue";
import MenuRouteCard from "./MenuRouteCard.vue";
import * as routesPlanningApi from "../../../backend/routesPlanningApi.js";
import { deleteRoute } from "../../../backend/routesApi.js";

export default {
  components: {
    RoutesShippingsDialog,
    MenuRouteCard,
  },
  props: ["route"],
  data() {
    return {
      menuRouteCard: false,
      loading: false,
    };
  },
  computed: {
    routeLoadingDate() {
      const routeShippingsLoadingDates = [];
      this.route.phases.forEach(s => {
        if (s.carLoadingDate && s.carLoadingDate.fact) {
          routeShippingsLoadingDates.push(this.moment(s.carLoadingDate?.fact));
        } else {
          return;
        }
      });
      if (routeShippingsLoadingDates.length) {
        return this.moment.min(routeShippingsLoadingDates).format();
      } else {
        return null;
      }
    },
    routes() {
      return this.$store.getters["routePlanning/planningRoutes"];
    },
    routesColors() {
      return this.$store.getters["routePlanning/routesColors"];
    },
    planningData() {
      return this.$store.getters["routePlanning/getPlanningData"];
    },
    isInCar() {
      if (!this.route.phases.length) {
        return false;
      }
      return !!this.route.phases.find(s => s.inCar === true);
    },
    compactMode() {
      return this.$store.getters["routePlanning/compactMode"];
    },
  },
  methods: {
    async deleteRoute() {
      this.loading = true;
      let message = "";
      if (this.route.routeId) {
        await deleteRoute(this.route.routeId);
        message = "Маршрут удален";
      } else if (this.route.draftId) {
        await routesPlanningApi.deleteRouteDraft(this.route.draftId);
        message = "Черновик маршрута удален";
      } else {
        this.loading = false;
        return;
      }

      const phases = [...this.planningData];
      phases.forEach(i => {
        if (this.route.routeId && i.route?.id === this.route.routeId) {
          i.route = null;
          i.routeColor = "";
          i.routeItemId = null;
        } else if (this.route.draftId && i.draft?.id === this.route.draftId) {
          i.draft = null;
          i.routeColor = "";
        } else {
          return;
        }
      });
      this.$store.commit("routePlanning/setPlanningData", phases);
      this.$store.commit("routePlanning/setChangedItemRow", true);
      await this.$store.dispatch("routePlanning/getPlanningRoutes");
      this.showInfo(message);
      this.loading = false;
    },
    async createRoute() {
      if (this.route.routeId) {
        return;
      }
      this.loading = true;
      const result = await routesPlanningApi.createRoute(
        this.route.draftId,
        this.route.direction.id,
        this.route.phases,
      );
      this.$store.commit("routePlanning/setChangedItemRow", true);
      await this.$store.dispatch("routePlanning/getPlanningRoutes");
      const phases = [...this.planningData];
      phases.forEach(i => {
        if (this.route.phases.find(r => r.phaseId === i.phaseId)) {
          i.draft = null;
          i.route = { id: result.id, title: result.title };
          i.routeColor = assignColor(
            result.title.replace(/\D+/g, "") - 1,
            this.routesColors,
          );
          const route = this.routes.find(r => r.routeId === result.id);
          const phase = route?.phases.find(p => p.phaseId === i.phaseId);
          i.routeItemId = phase.routeItemId;
        }
      });
      this.$store.commit("routePlanning/setPlanningData", phases);

      this.loading = false;
      this.showInfo(`Маршрут сформирован. Номер маршрута ${result.title}`);

      function assignColor(routeIndex, colors) {
        let diff = +routeIndex;
        while (diff > colors.length - 1) {
          diff = diff - (colors.length - 1);
        }
        return colors[diff];
      }
    },
    filterBy(routeTitle) {
      this.$store.dispatch("routePlanning/changeRouteFilter", routeTitle);
    },
    resetLoaders() {
      this.loading = false;
    },
  },
};
</script>
